<template>
	<div class="msg-analysis-finder" v-if="!isError">
		<div class="msg-analysis-finder-img">
			<img :src="message.finderThumb" class="msg-analysis-finder-thumb" />
			<img src="/img/video_play.png"  class="msg-analysis-finder-play"/>
		</div>
		<div class="msg-analysis-finder-info">
			<img :src="message.finderAvatar"/>
			<p>{{message.finderNickname}}</p>
		</div>
		<div class="msg-analysis-finder-desc">
			<p>{{message.finderDesc}}</p>
		</div>
		<div class="msg-analysis-finder-tip">
			<img src="/img/finder.png"/>
			<p>视频号</p>
		</div>
	</div>
	<div class="msg-analysis-finder-error" v-else>
		视频号消息格式错误，请在手机端查看！
	</div>
</template>

<script>
	import AppConfig from '../../../config/AppConfig.js'
	export default{
		name: 'MsgAnalysisFinder',
		components:{
			
		},
		props:{
			msg:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			}
		},
		data(){
			return {
				message: {},
				isError: false
			}
		},
		methods:{
			format(){
				try {
					let obj = JSON.parse(this.msg.content)
					let finderThumb = obj.thumbUrl
					let finderAvatar = obj.avatar
					let finderDesc = obj.desc !== undefined ?  obj.desc : ''
					let finderNickname = obj.nickname !== undefined ? obj.nickname : '昵称为空'
					this.message = {
						finderThumb: finderThumb,
						finderAvatar: finderAvatar,
						finderDesc: finderDesc,
						finderNickname: finderNickname
					}
				}catch (e) {
					this.isError = true
				}
			}
		},
		
		created() {
			this.format()
		}
	}
</script>

<style>
	.msg-analysis-finder-error{
		background-color: #f19595;
		padding: 8px;
		font-size: 12px;
		border-radius: 2px;
	}
	.msg-analysis-finder{
		width: 220px;
		height: auto;
		cursor: pointer;
		background-color: #FFFFFF;
		border: 1px solid #e7e7e7;
		border-radius: 4px;
	}
	.msg-analysis-finder-img{
		width: 100%;
		height: auto;
		position: relative;
	}
	.msg-analysis-finder-img > .msg-analysis-finder-thumb{
		width: 100%;
		height: auto;
	}
	.msg-analysis-finder-img .msg-analysis-finder-play{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		width: 40px;
		height: 40px;
	}
	.msg-analysis-finder-info{
		height: 40px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 14px;
	}
	.msg-analysis-finder-info > img{
		width: 22px;
		height: 22px;
		display: block;
		margin: 0 5px;
		border-radius: 11px;
	}
	.msg-analysis-finder-desc{
		padding: 0 5px;
		font-size: 12px;
		height: 20px;
		line-height: 20px;
	}
	.msg-analysis-finder-desc p{
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.msg-analysis-finder-tip{
		border-top: 1px solid #EEEEEE;
		margin-top: 5px;
		padding: 5px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 12px;
	}
	.msg-analysis-finder-tip > img{
		width: 18px;
		height: 18px;
		display: block;
		margin: 0 5px;
	}
</style>
